const AUD = new Intl.NumberFormat('en-AU', {
  style: 'currency',
  currency: 'AUD',
  maximumFractionDigits: 0,
});

const MONTH_NAMES = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

/** centsToAud(4046400) → "$40,464" */
export function centsToAud(cents: number | null | undefined): string {
  if (cents == null) return '—';
  return AUD.format(cents / 100);
}

/** [2, 7] → "Feb · Jul" */
export function formatIntakes(months: number[]): string {
  if (!months.length) return '—';
  return months
    .filter((m) => m >= 1 && m <= 12)
    .map((m) => MONTH_NAMES[m - 1])
    .join(' · ');
}

/** ISO timestamp → "14 May 2026" */
export function formatDate(iso: string | null | undefined): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('en-AU', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

/** "higher_education" → "Higher education" */
export function humanise(s: string): string {
  return s
    .split('_')
    .map((p, i) => (i === 0 ? p.charAt(0).toUpperCase() + p.slice(1) : p))
    .join(' ');
}
